export function resetFilterArray(stateObj, key) {
  const target = stateObj[key];
  if (Array.isArray(target)) {
    stateObj[key] = [];
  }
}

export function hasFilterValue(stateObj, key, value, matchKey = 'id') {
  const array = stateObj[key];
  if (!Array.isArray(array)) return false;

  const isObjectArray = array.length > 0 && typeof array[0] === 'object';

  if (isObjectArray && typeof value === 'object') {
    return array.some(item => item?.[matchKey] === value?.[matchKey]);
  } else {
    return array.includes(value);
  }
}

export function toggleFilterValue(stateObj, key, value, matchKey = 'id') {
  const array = stateObj[key];
  if (!Array.isArray(array)) return;

  const isObjectArray = array.length > 0 && typeof array[0] === 'object';
  let index;

  if (isObjectArray && typeof value === 'object') {
    index = array.findIndex(item => item?.[matchKey] === value?.[matchKey]);
  } else {
    index = array.indexOf(value);
  }

  if (index === -1) {
    array.push(value);
  } else {
    array.splice(index, 1);
  }
}

export function toggleBooleanFilter(obj, key) {
  if (typeof obj[key] === 'boolean') {
    obj[key] = !obj[key];
  }
}

export function areFiltersEmpty(filters) {
  return Object.values(filters).every(value => {
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'boolean') return value === false;
    return true; // consider unknown types as "empty"
  });
}
